import { Link } from 'react-router-dom';
import { ShieldMark } from '../components/ShieldMark';

export function NotFoundPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-24 text-center">
      <div className="text-terracotta mb-8 flex justify-center">
        <ShieldMark size={80} />
      </div>
      <h1 className="text-5xl text-forest mb-6 leading-tight font-display">Page not found.</h1>
      <p className="text-lg text-forest/75 mb-10">
        The page you were looking for has moved or never existed.
      </p>
      <Link
        to="/"
        className="border-2 border-forest text-forest px-8 py-3 text-sm tracking-[0.1em] uppercase hover:bg-forest hover:text-cream transition-colors"
      >
        ← Back to home
      </Link>
    </div>
  );
}
